import events from '~/modules/game-events/game-events';
import RemoteMicServer from '~/modules/remote-mic/network/server';
import RemoteMicManager from '~/modules/remote-mic/remote-mic-manager';
import { remoteQueueEntries } from '~/modules/song-queue/remote-queue';
import SongQueue, { SongQueueItem } from '~/modules/song-queue/song-queue';
import SongsService from '~/modules/songs/songs-service';
import isPreRendering from '~/modules/utils/is-pre-rendering';

/**
 * A phone asking for a song joins the queue rather than interrupting what is playing. The song is
 * resolved here, on the machine that owns the queue, so the phone only ever sends an id.
 */
events.remoteSongQueued.subscribe(async (senderId, songId) => {
  const song = (await SongsService.getIndex()).find((entry) => entry.id === songId);
  if (!song) return;

  SongQueue.add(song, undefined, RemoteMicManager.getRemoteMicById(senderId)?.name, senderId);
});

const publishQueue = (queue: readonly SongQueueItem[]) =>
  RemoteMicServer.publish('song-queue', remoteQueueEntries(queue));

SongQueue.addListener(publishQueue);
if (!isPreRendering) publishQueue(SongQueue.getQueue());
